import qs from 'qs'

export default qs
